import { render, staticRenderFns } from "./PayslipRecurringPolicyAssignUserDetailsView.vue?vue&type=template&id=93175de6&"
import script from "./PayslipRecurringPolicyAssignUserDetailsView.vue?vue&type=script&lang=js&"
export * from "./PayslipRecurringPolicyAssignUserDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./PayslipRecurringPolicyAssignUserDetailsView.vue?vue&type=style&index=0&id=93175de6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports